import { selectors } from './constants';
import filterActiveCompleteSteps from './filterActiveCompleteSteps';

/**
 * Gets all fields in an element (eg. form or panel)
 *
 * @param {Element} element
 */
export default function getFields(element) {
  if (!element) return [];

  return filterActiveCompleteSteps(
    Array.from(element.querySelectorAll(selectors.fields.join(','))),
    element
  );
}
